export enum UserRole {
  None = 0,
  Admin = 1,
  User = 2,
  Extern = 3,
  Streetworker = 4,
  AdminReadOnly = 5,
  TrackerRegistor = 6,
}

export interface AuthenticateRequest {
  email: string;
  password: string;
}

export interface AuthenticatedResponse {
  step: 'authenticated';
  id: number;
  title: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  created: string;
  updated: string | null;
  isVerified: boolean;
  jwtToken: string;
}

export interface TwoFactorChallengeResponse {
  step: 'requires_two_factor';
  twoFactorToken: string;
}

export interface TwoFactorSetupChallengeResponse {
  step: 'requires_two_factor_setup';
  twoFactorSetupToken: string;
  secretKey?: string;
  authenticatorUri?: string;
  email?: string;
}

export interface TwoFactorVerifyRequest {
  twoFactorToken: string;
  code: string;
}

export type LoginResponse =
  | AuthenticatedResponse
  | TwoFactorChallengeResponse
  | TwoFactorSetupChallengeResponse;

export type AuthenticateResponse = AuthenticatedResponse;
